enum TemsPolicy {
    OperatorPolicy,
    AuthorizedClientPolicy,
    ServicePolicy,
    ProductionPolicy,
    DeveloperPolicy,

    ConfirmedPolicy
}
export default TemsPolicy;

export enum ViewModelUserLevel {
    None = 0,
    Operator = 1,
    AuthorizedClient = 2,
    Service = 3,
    Production = 4,
    Developer = 5
}

export function UserLevelToPolicyConverter(userLevel: ViewModelUserLevel): TemsPolicy {
    var level: number = <number>userLevel;
    level--;
    return <TemsPolicy> level;
}